function ucWords(str: string) {
  var splitStr = str.toLowerCase().split(" ");
  if (splitStr.length <= 1) {
    return str;
  }
  for (var i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  // Directly return the joined string
  return splitStr.join(" ");
}

function dateNow() {
  const today = new Date();
  const yyyy = today.getFullYear();
  var mm = today.getMonth() + 1; // Months start at 0!
  var dd = today.getDate();

  var dds = dd.toString();
  var mms = mm.toString();

  if (dd < 10) {
    dds = "0" + dds;
  }
  if (mm < 10) {
    mms = "0" + mms;
  }

  const formattedToday = yyyy + "-" + mms + "-" + dds;
  return formattedToday;
}

export { ucWords, dateNow };
